<div class="wizard-steps-indicator" [class.flush]="flush">
    @for (passo of passos; track $index) {
    <div class="wizard-step-item" [class.ativo]="passoAtual === $index" [class.concluido]="passoAtual > $index"
        [class.clicavel]="clicavel"
        [attr.role]="clicavel ? 'button' : null"
        [attr.tabindex]="clicavel ? 0 : null"
        (click)="onPassoClick($index)"
        (keydown.enter)="onPassoClick($index)"
        (keydown.space)="$event.preventDefault(); onPassoClick($index)">
        <div class="step-circle">
            @if (passoAtual > $index) {
            <mat-icon class="material-symbols-outlined step-check">check</mat-icon>
            } @else {
            <span class="step-number">{{ $index + 1 }}</span>
            }
        </div>
        <span class="step-label">{{ passo }}</span>
    </div>
    @if ($index < passos.length - 1) {
    <div class="step-connector"
        [class.concluido]="passoAtual > $index"
        [class.adjacente-ativo]="$index === passoAtual || $index === passoAtual - 1"></div>
    }
    }
</div>

@if (exibirAlerta && passos && passos.length > 0 && passoAtual >= 0 && passoAtual < passos.length) {
<div class="wizard-step-alert-container" [class.flush]="flush">
    <app-alert-card [type]="tipoAlerta" [title]="tituloEtapaCorrente">
        @if (descricaoEtapaCorrente) {
        <span>{{ descricaoEtapaCorrente }}</span>
        }
    </app-alert-card>
</div>
}


